import { createFileRoute } from '@tanstack/react-router';

import { StartPageLink, TextPage } from '../../components/PlaceholderPage.js';

/**
 * A logged-in Account User opened a path that matches no page
 * (`ux.md`, States, "Page not found"). It sits inside `_app`, so it shows
 * within the dashboard frame and only once the session check has passed — a
 * path that matches no page still shows no account data to someone with no
 * session.
 */
export const Route = createFileRoute('/_app/$')({
  component: PageNotFound,
});

function PageNotFound() {
  return (
    <TextPage title="Page not found" action={<StartPageLink />}>
      There&apos;s no page at this address.
    </TextPage>
  );
}
